import Button from 'components/button/Button';
import styled from 'styled-components';

export const GuestNameCellStyled = styled(Button)`
  padding: 0;
`;
